import { ApolloProvider } from '@apollo/client'
import { apolloClient } from './apollo/client'
import { BrandVariants, createLightTheme, FluentProvider, Theme } from '@fluentui/react-components'
import { QueryProvider } from './contexts/QueryProvider'
import { DotnetClientProvider } from './contexts/DotnetClientContext'
import { ThemeProvider } from './theme-provider'

const pwcOrangeVariants: BrandVariants = {
  10: '#0A0100',
  20: '#310803',
  30: '#520205',
  40: '#690006',
  50: '#7F0005',
  60: '#950903',
  70: '#A81B01',
  80: '#B92E00',
  90: '#C94000',
  100: '#D75306',
  110: '#E36715',
  120: '#ED7B28',
  130: '#F58F3D',
  140: '#FCA456',
  150: '#FFB975',
  160: '#FFCE9C',
}

const pwcLightTheme: Theme = {
  ...createLightTheme(pwcOrangeVariants),
  colorBrandBackground: pwcOrangeVariants[100],
  colorBrandBackgroundInvertedSelected: pwcOrangeVariants[140],
  fontFamilyBase: 'unset',
  lineHeightBase300: 'unset',

  //  colorNeutralBackground1: "unset"
  //  colorBrandForeground1: pwcOrangeVariants[110],
  //  colorBrandForeground2: pwcOrangeVariants[130]
}

export const Providers = ({ children }: { children: React.ReactNode }) => {
  return (
    <ApolloProvider client={apolloClient}>
      <QueryProvider>
        <DotnetClientProvider>
          <ThemeProvider defaultTheme="light" storageKey="vite-ui-theme">
            <FluentProvider theme={pwcLightTheme}>
              {children}
            </FluentProvider>
          </ThemeProvider>
        </DotnetClientProvider>
      </QueryProvider>
    </ApolloProvider>
  )
}
